<template>
  <section
    id="tools-susi"
    ref="toolsSusi"
  >
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="filters"
          title="Susi - Serviços e Rotinas"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <b-row>
            <b-col cols="10">
              <h4>Helpdesk - Freshdesk - Respondedor de Ticket</h4>
              <p class="font-medium-1">
                Funcionamento:<br />
                Rotina que roda a cada 10 minutos, deixa a resposta pronta para todos os tickets abertos no helpdesk<br />
                <br />
                Links úteis:<br />
                <a
                  target="_blank"
                  :href="`${settings.url}/logs?hash=${settings.logs}`"
                >Acessar logs</a>
                <br />
                <a
                  target="_blank"
                  :href="`${settings.url}/freshdesk-prompt?hash=${settings.salesiq}`"
                >Alterar prompt do respondedor</a><br />
              </p>
            </b-col>

            <b-col cols="10">
              <hr />

              <h4>Sales IQ - Tagueamento</h4>
              <p class="font-medium-1">
                Rotina de tagueamento que roda a cada 10 minutos nos chats encerrados, interpretando o contexto e adicionando uma ou mais tags à conversa.<br />
                <br />

                Links úteis:<br />
                <a
                  target="_blank"
                  :href="`${settings.url}/logs?hash=${settings.logs}`"
                >Acessar logs</a><br />
                <a
                  target="_blank"
                  :href="`${settings.url}/sales-iq?hash=${settings.salesiq}`"
                >Alterar/Testar prompt de tagueamento</a><br />
              </p>
            </b-col>

            <b-col cols="10">
              <hr />

              <h4>Sales IQ - ChatBot</h4>
              <p class="font-medium-1">
                Serviço que responde as perguntas dos usuários que estão conversando o chatbot.<br />
                <br />

                Links úteis:<br />
                <a
                  target="_blank"
                  :href="`${settings.url}/logs?hash=${settings.logs}`"
                >Acessar logs</a>
              </p>
            </b-col>

            <b-col cols="10">
              <hr />

              <h4>WhatsApp</h4>
              <p class="font-medium-1">
                Serviço que responde as perguntas dos usuários que estão conversando com os bots(Alerta 1, Alerta 2) do WhatsApp.<br />
                <br />

                Links úteis:<br />
                <a
                  target="_blank"
                  :href="`${settings.url}/logs?hash=${settings.logs}`"
                >Acessar logs</a>
              </p>
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import SusiService from '@/services/susiService'
import { formatDateTimeDbToView } from '@/utils/helpers'
import {
  BRow,
  BCol,
  BBreadcrumb,
} from 'bootstrap-vue'
import toast from '@/mixins/toast'

export default {
  components: {
    BCardActions,
    BRow,
    BCol,
    BBreadcrumb,
  },
  mixins: [
    toast,
  ],
  data() {
    return {
      userService: null,
      isLoading: false,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas',
          active: true,
        },
        {
          text: 'Susi',
          active: true,
        },
      ],
      results: [],
      settings: {},
      formatDateTimeDbToView,
    }
  },
  computed: {
  },

  created() {
    this.getSettings()
  },

  methods: {
    getSettings() {
      SusiService.getConfigHashes().then(response => {
        if (response.data !== null) {
          this.settings = response.data.data
        }
      })
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .no-padding {
    padding: 0px!important;
  }

  .header-card{
    margin-bottom: 20px;
  }

  .form-buttons button{
    margin-right: 10px;
  }
</style>
